function GetYear() {

    let getYear = (new Date().getFullYear());
   
    return (
         <p className="footer__copyright">
            {getYear} &copy; / pult.ru / все права защищены
        </p>
    )
}
export default GetYear;